import { useState } from "react";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { getArrayIsNotEmpty } from "../../../SharedComponents/utils/helpers/getArrayIsNotEmpty";
import { getFallbackMakeLogoImage } from "../../utils/helpers/userCarHelpers/getFallbackMakeLogoImage";
import ActiveRequestTableInAllRequestsPage from "../Tables/Table/ActiveRequestsTableInAllRequestsPage";
import UnActiveRequestsTableInAllRequestsPage from "../Tables/Table/UnActiveRequestsTableInAllRequestsPage";
import TableShowArrowIconSVG from "../../assets/icons/svg/TableShowArrowIconSVG";
import TableHideArrowIconSVG from "../../assets/icons/svg/TableHideArrowIconSVG";

export const SingleUserCarRequestsComponent = ({ car }) => {
    const [tablesOpen, setTablesOpen] = useState(false);

    const GetEndArrowComponent = () => {
        return (
            <div
                style={styles.arrowContainer}
                onClick={() => setTablesOpen(!tablesOpen)}
            >
                {tablesOpen ? <TableHideArrowIconSVG /> : <TableShowArrowIconSVG />}
            </div>
        );
    };

    const GetTableTopComponent = () => {
        const getImageSource = () => {
            const carMake = car.Make.name;
            const images = car.UserCarImages;
            return getArrayIsNotEmpty(images) ? images[0] : getFallbackMakeLogoImage(carMake);
        };

        const getCarDescSubtitle = () => {
            return `${car.Make.name} • ${car.Model.name} • ${car.Generation.name} • ${car.Motor.name}`;
        };

        return (
            <div style={styles.tableTopMainContainer}>
                <div style={styles.selectedItemContainer}>
                    <img
                        src={getImageSource()}
                        style={styles.carImage}
                    />
                    <div>
                        <p style={styles.carNameText}>{car.title}</p>
                        <p style={styles.carDescriptionText}>{getCarDescSubtitle()}</p>
                    </div>
                </div>
                {GetEndArrowComponent()}
            </div>
        );
    };

    return (
        <div style={styles.mainContainer}>
            {GetTableTopComponent()}

            {tablesOpen && (
                <div style={styles.tablesContainer}>
                    <ActiveRequestTableInAllRequestsPage id={car.user_car_id} />
                    <UnActiveRequestsTableInAllRequestsPage id={car.user_car_id} />
                </div>
            )}
        </div>
    );
};

export default SingleUserCarRequestsComponent;

const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
    tableTopMainContainer: {
        display: "flex",
        alignItems: 'center',
        justifyContent: 'space-between',
        border: "1px solid #0000003b",
        backgroundColor: "#F3F4F6",
        borderRadius: 2,
        paddingInline: 12,
        paddingTop: 10,
        paddingBottom: 10,
    },
    selectedItemContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
    },
    carImage: {
        width: "48px",
        height: "48px",
        border: "1px solid #0000003b",
        borderRadius: 8,
        objectFit: "cover",
    },
    carNameText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 600,
        color: "#000000",
    },
    carDescriptionText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de",
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
    },
    arrowContainer: {
        cursor: 'pointer',
    },
    tablesContainer: {
        paddingLeft: 30,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
};
